import { Component, OnInit } from '@angular/core';
import { UserService } from '@carm/_core/access-control-mgt/facade/user.service';
import { GroupTypes } from '@carm/_core/access-control-mgt/models';
import { MenuService } from '@carm/base-layout/main/main-header/services/menu.service';
import { applicationFeaturesArray } from '@carm/shared/constants/const-application-features';
import { combineLatest, merge, Observable, of } from 'rxjs';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { CarmResources } from '@carm/_core/access-control-mgt/models';
import { ProgramFacadeService } from '@carm/_core/program-account-profile/services/program-facade.service';
import { NotificationService } from '@carm/_core/notification-mgt/facade/notifcation.service';
import { TranslateService } from '@ngx-translate/core';
import { filter, map } from 'rxjs/operators';

@Component({
  selector: 'carm-dashboard-onboarding-documentation-page',
  templateUrl: './dashboard-home-page.component.html',
  styleUrls: ['./dashboard-home-page.component.scss'],
})
export class DashboardHomePageComponent implements OnInit {
  features = applicationFeaturesArray();
  lastLoggedOut$: Observable<Date>;
  groupType = GroupTypes;
  carmResourceEnum = CarmResources;

  constructor(
    private menuService: MenuService,
    private notificationService: NotificationService,
    private userService: UserService,
    private programFacadeService: ProgramFacadeService,
    private translateService: TranslateService,
    public activatedRoute: ActivatedRoute,
    private router: Router,
  ) {}

  ngOnInit() {

    let filteredApplicationFeaturesArray = this.features.filter( item => {
      return !item.dataCy.includes('Homepage')
    })

    this.features = filteredApplicationFeaturesArray
    this.menuService.showMenu = true;
    this.lastLoggedOut$ = this.userService.getUserLastLoggedLogout();

    const currentProgram$ = merge(
      of(null),
      this.router.events.pipe(
        filter((event): event is NavigationEnd => event instanceof NavigationEnd)
      )
    ).pipe(
      map(() => {
        const urlParts = this.router.url.split('/');
        const isDashboard = urlParts.includes('dashboard');
        const currentPrg = urlParts.find((part: string) => part.includes('RM'));
        return isDashboard ? currentPrg : undefined;
      })
    );
    combineLatest([
      currentProgram$,
      this.programFacadeService.getInactivePrograms()
    ]).subscribe(([currentPrg, inactivePrgList]) => {
      if (currentPrg && inactivePrgList.includes(currentPrg)) {
        this.notificationService.setPageWarningMessage(
          this.translateService.instant('common.program-inactive-banner-message', {
            programBN15: currentPrg
          }),
          this.translateService.instant('common.program-inactive-banner-title')
        );
      } else {
        this.notificationService.clearNotification();
      }
    });
  }
}
